import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAdministrationRequestApproveAPI } from '@innowise-group/core';
import { Modal, modalHoc, ModalProps } from '@innowise-group/mui-kit';

import * as Styled from './request-decline-modal.styles';
import { notificationsManager } from '@innowise-group/mui-kit';

interface RequestDeclineModalProps {
  id: number;
  vacancyName: string;
  departmentName: string;
  onOperationCompleted?: (id?: number) => void;
}

const RequestDeclineModal: React.FC<ModalProps & RequestDeclineModalProps> = ({
  close,
  id,
  vacancyName,
  departmentName,
  onOperationCompleted,
}) => {
  const { t } = useTranslation();
  const [isBusy, setBusy] = useState(false);

  const { setAdministrativeRequestClarify } = useAdministrationRequestApproveAPI();

  const handleProcess = useCallback(() => {
    setAdministrativeRequestClarify(id, false)
      .then(() => {
        onOperationCompleted(id);
        close();
      })
      .catch(() => {
        notificationsManager.error({
          title: t('pages.requests.decliningModal.notRejected'),
          subtitle: t('notifications.text.networkError'),
        });
      })
      .finally(() => setBusy(false));
  }, [id, setAdministrativeRequestClarify, onOperationCompleted]);

  return (
    <Modal.Container size="small">
      <Modal.Header onClose={close}>
        <Styled.ModalTitle>{t('pages.requests.decliningModal.confirmDecline')}</Styled.ModalTitle>
      </Modal.Header>
      <Modal.Body>
        <Styled.Description>
          <div>{t('pages.requests.decliningModal.requestWillArchivedAfterDeclining', { request: id })}</div>
          <div>{t('pages.requests.decliningModal.vacancy', { vacancy: vacancyName })}</div>
          <div>{t('pages.requests.decliningModal.department', { department: departmentName })}</div>
        </Styled.Description>
      </Modal.Body>
      <Styled.Footer>
        <Styled.CancelButton onClick={close} variant="outlined">
          {t('buttons.cancel')}
        </Styled.CancelButton>
        <Styled.SubmitButton onClick={handleProcess} disabled={isBusy}>
          {t('buttons.approve')}
        </Styled.SubmitButton>
      </Styled.Footer>
    </Modal.Container>
  );
};

export default modalHoc(RequestDeclineModal, 'request-decline');
